import { Injectable, inject } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../model/reducer';
import { Observable } from 'rxjs';
import { Diff } from '../../../common/model/publish-changes/diff.model';
import { TextDiffData } from '../../../common/model/publish-changes/text-diff-data.model';
import { bundlesDiffView } from '../../../model/views';
import { PublishProjectContext } from '../publish-project.context';
import { TextDiffWrapperContext } from '../text-diff-wrapper/text-diff-wrapper.model';

@Injectable()
export class BundlesDiffViewContext extends TextDiffWrapperContext {
  private store$ = inject<Store<AppState>>(Store);
  private publishProjectContext = inject(PublishProjectContext);


  readonly textDiff$: Observable<Diff<TextDiffData> | null>;
  readonly currentBranch$: Observable<string | null>;

  constructor() {
    super();
    this.textDiff$ = this.store$.pipe(select(bundlesDiffView));
    this.currentBranch$ = this.publishProjectContext.currentBranch$;
  }

}
